import { FormlyModule } from '@ngx-formly/core';
import {
  RECAPTCHA_SETTINGS,
  RECAPTCHA_LANGUAGE,
  RecaptchaModule,
  RecaptchaFormsModule,
} from 'ng-recaptcha';

import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RecaptchaFormFieldComponent } from './components/recaptcha-form-field/recaptcha-form-field.component';

@NgModule({
  imports: [
    // Angular
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    // Recaptcha
    RecaptchaModule,
    RecaptchaFormsModule,
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'recaptcha',
          component: RecaptchaFormFieldComponent,
          wrappers: [],
        },
      ],
    }),
  ],
  declarations: [RecaptchaFormFieldComponent],
})
export class SnFormRecaptchaModule {
  public static forRoot(apiKey: string): ModuleWithProviders<SnFormRecaptchaModule> {
    return {
      ngModule: SnFormRecaptchaModule,
      providers: [
        {
          provide: RECAPTCHA_SETTINGS,
          useValue: { siteKey: apiKey },
        },
        {
          provide: RECAPTCHA_LANGUAGE,
          useValue: 'en',
        },
      ],
    };
  }
}
